import { render, staticRenderFns } from "./OpRadioGroup.vue?vue&type=template&id=3dbf8bbb&scoped=true&"
import script from "./OpRadioGroup.vue?vue&type=script&lang=js&"
export * from "./OpRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./OpRadioGroup.vue?vue&type=style&index=0&id=3dbf8bbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf8bbb",
  null
  
)

export default component.exports